export default {
  barTitle: 'Cookies',
  barDescription: 'Nós utilizamos os nossos próprios cookies e de terceiros para que possamos lhe mostrar este site e compreender a forma como o utiliza, de forma a melhorarmos os serviços que oferecemos. Ao continuar a navegar no site, consideramos que aceitou a utilização de cookies.',
  acceptAll: 'Aceitar todos',
  declineAll: 'Apagar todos',
  manageCookies: 'Gerir cookies',
  unsaved: 'Tem alterações não guardadas',
  close: 'Fechar',
  save: 'Gravar',
  necessary: 'Cookies necessários',
  optional: 'Cookies opcionais',
  functional: 'Cookies funcionais',
  blockedIframe: 'Para visualizar isto, por favor, active os cookies funcionais',
  here: 'aqui'
}